export const setCurrentlyChecking = (payload) => {
    return {
        type: 'SET_CURRENTLYCHECKING',
        payload: payload
    }
};
